import * as React from 'react'
import * as ReactDOMServer from 'react-dom/server'

import {DialogOverlay} from './DialogOverlay'
import {DIALOG} from './DialogManager'

interface DialogSettings {
    closeOnBackgroundClick: boolean;
}

const DEFAULT_DIALOG_SETTINGS: DialogSettings = { closeOnBackgroundClick: false }
let DialogSequence = 0

export class Dialog {
	dialogElement: JQuery
	tableId: number
	open: boolean
	settings: DialogSettings
	dialogContent: JQuery
	id: string
	parentContainer: JQuery


	/**
     * @param parentContainer
     * @param dialogContent
     * @param settings
     * @param tableId
     * @param settings.closeOnBackgroundClick
     */
	constructor(
		parentContainer: JQuery,
		dialogContent: JQuery,
		tableId?: number,
		settings: DialogSettings = DEFAULT_DIALOG_SETTINGS
	) {
		this.dialogElement = null
		this.tableId = null
		this.open = false
		this.settings = settings
		this.dialogContent = dialogContent
		this.parentContainer = parentContainer
		this.id = 'dialog-' + DialogSequence++
		if (tableId !== undefined) {
			this.tableId = tableId
		}
		this.render()
	}

	isOpen(): boolean {
		return this.open
	}

	render() {
		const dialogOverlay = <DialogOverlay id={this.id}/>
		const html = ReactDOMServer.renderToStaticMarkup(dialogOverlay)
		this.parentContainer.append(html)

		this.dialogElement = $('#' + this.id)

		if (this.settings.closeOnBackgroundClick) {
			this.dialogElement.touchSafeClick(() => { this.close() })
		}
		const content = this.dialogElement.find('.' + DIALOG.CONTENT)
		content.append(this.dialogContent.html())

		this.dialogElement.hide()
	}

	show(): void {
		this.open = true
		this.dialogElement.show()
	}

	close(): void {
		this.open = false
		$('#' + this.id).remove()
	}

	getElement(): JQuery {
		return this.dialogElement
	}
}
